export const iconFontAwesomeMoneyPesetaSign = (
	<i className="fa-solid fa-peseta-sign"></i>
);
